import * as React from "react";
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.61}
        d="M13.921 32.337V27.86m6.692 4.477v-8.954m6.69 8.954v-13.43m4.461 22.383H9.461A4.469 4.469 0 0 1 5 36.814V5.477A4.469 4.469 0 0 1 9.46 1H21.92c.591 0 1.159.236 1.577.656l12.076 12.119c.418.42.653.989.653 1.582v21.457a4.469 4.469 0 0 1-4.46 4.476Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
